import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetChannels from '@/modules/manage-player/api/hooks/useQueryGetChannels'
import GetChannelListing from '@/modules/manage-player/components/GetChannel/GetChannelListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function GetChannelPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		name: searchQuery,
	}

	const { data, isLoading } = useQueryGetChannels(payload)

	return (
		<PageContainer>
			<GetChannelListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedGetChannelPage = withUserPermission(GetChannelPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_PLAYER],
})

export default GuardedGetChannelPage
